export enum SamplingTargetUnitOfMeasure {
    Number = 1,
    Percentage = 2,
}
